/* eslint-disable */
import { StarIcon, Upload } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircleIcon } from '../../../assets/icons/HelpCircleIcon';
import { Button } from '../Button';
import GBTAUploadModal from '../GBTAUploadModal';
import { DialogActions, DialogHeader, DialogTitle, HotelName } from './index';
import { Hotel } from '../../../hooks/useHotels';
import { canShowGBTAUpload } from './utils';
import { useAuth } from '../../../contexts/AuthContext';
import { Badge } from '../Badge';
import { useHotelDetail } from '../../../contexts/HotelDetailContext';
import { canUploadGBTA } from '../../../utils';
import { Tooltip } from '../Tooltip';
interface HotelDetailDialogHeaderProps {
  hotel: Hotel;
  handleClose: () => void;
}
const HotelDetailDialogHeader = ({
  hotel,
  handleClose,
}: HotelDetailDialogHeaderProps) => {
  const navigate = useNavigate();
  const { showBoostUpgrade, hotelSubscription } = useHotelDetail();
  const { isSuperAdmin, user } = useAuth();
  const [isGBTAModalOpen, setIsGBTAModalOpen] = useState(false);

  const hasGBTAUploadPermission = canUploadGBTA(hotelSubscription);
  const canShowUpgradeButton = !isSuperAdmin;
  const handleGBTAUploadClick = () => {
    setIsGBTAModalOpen(true);
  };

  const handleGBTAModalClose = () => {
    setIsGBTAModalOpen(false);
  };

  const handleUpgradeClick = () => {
    if (hotelSubscription?.subscription_name.toLowerCase() === 'boost') {
      return;
    }
    navigate(`/upgrade?hotelId=${hotel.id}`);
  };

  const renderBadge = () => {
    if (hotelSubscription?.subscription_name.toLowerCase() === 'boost') {
      return <Badge variant="success">Boost</Badge>;
    } else if (
      hotelSubscription?.subscription_name.toLowerCase() === 'essentials'
    ) {
      return <Badge variant="warning">Essentials</Badge>;
    }
    return null;
  };

  const getUpgradeLabel = () => {
    if (hotelSubscription?.subscription_name.toLowerCase() === 'boost') {
      return 'Boosted';
    } else if (
      hotelSubscription?.subscription_name.toLowerCase() === 'essentials'
    ) {
      return 'Boost';
    }
    return 'Upgrade';
  };

  const getTooltipText = () => {
    if (hotelSubscription?.subscription_name.toLowerCase() === 'boost') {
      return 'Subscribed to Boost';
    } else return 'Upgrade Your Hotel';
  };
  return (
    <>
      <DialogHeader>
        <DialogTitle>
          <HotelName>
            {hotel.hotel_location_name}{' '}
            <span className="ml-1">{renderBadge()}</span>
          </HotelName>
          {/* <HotelLocation>
            {hotel.city}, {hotel.country}
          </HotelLocation> */}
        </DialogTitle>
        <DialogActions>
          {/* <HelpCircleIcon
            color="var(--color-gray-400)"
            className="cursor-pointer mr-3"
          /> */}
          {canShowUpgradeButton && (
            <Tooltip
              content={getTooltipText()}
              position="left"
              icon={
                <Button
                  variant="primary"
                  size="lg"
                  icon={<StarIcon className="w-4 h-4" />}
                  className="bg-planet-green hover:bg-planet-green rounded-xl text-white font-semibold"
                  onClick={handleUpgradeClick}
                >
                  {getUpgradeLabel()}
                </Button>
              }
            />
          )}

          {hasGBTAUploadPermission && canShowGBTAUpload(hotel) && (
            <Tooltip
              content="Upload GBTA Data"
              icon={
                <Button
                  variant="primary"
                  size="lg"
                  icon={<Upload className="w-4 h-4" />}
                  className="bg-gray-900 hover:bg-gray-900 rounded-xl text-white font-semibold"
                  onClick={handleGBTAUploadClick}
                >
                  GBTA Upload
                </Button>
              }
            />
          )}
        </DialogActions>
      </DialogHeader>

      <GBTAUploadModal
        isOpen={isGBTAModalOpen}
        onClose={handleGBTAModalClose}
        hotelId={hotel.id}
      />
    </>
  );
};
export default HotelDetailDialogHeader;
